import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import StageWithText from 'commonComponents/Stages/StageWithText/StageWithText';
import FullWidthBlocks from 'commonComponents/FullWidthBlocks/FullWidthBlocks';
import styles from '../pages.module.scss';
import './ProjectsCMS.scss';

const ProjectsPage = ({ banner, boxes }) => {

  const boxesHTML = ReactHtmlParser(boxes);
  const boxRender = box => box;

  return (
    <div className={ styles.Page }>
      <StageWithText { ...banner } pageName="projects" />
      <FullWidthBlocks
        anchor='projects'
        boxes={ boxesHTML }
        boxRender={ boxRender }
      />
    </div>
  );
};
 
export default ProjectsPage;
